// The Atlassian icon the predefined `atlassian` MCP server already uses, in
// packages/integrations/agentic/shared/src/mcp/saas/atlassian.ts.
export const JiraAiIconUrl = "https://www.atlassian.com/apple-touch-icon.png";
